import {
  AMBULANCE_LIST,
  AMBULANCE_LIST_SUCCESS,
  AMBULANCE_LIST_ERROR,
  AMBULANCE_PAGE_SET,
  AMBULANCE_SEARCH_SET,
  AMBULANCE_SEARCH_CHANGE,
  AMBULANCE_DETAIL,
  AMBULANCE_DETAIL_SUCCESS,
  AMBULANCE_DETAIL_ERROR,
  AMBULANCE_VIEW_MODAL_SET,
  AMBULANCE_MAINTENANCE_UPDATE,
  AMBULANCE_MAINTENANCE_UPDATE_SUCCESS,
  AMBULANCE_MAINTENANCE_UPDATE_ERROR,
  AMBULANCE_ADD_MODAL_SET,
  AMBULANCE_ADD_CHANGE
} from '../actions';

const INIT_STATE = {
  loading: true,
  list: {
    page: { current: 1, rows: 9 },
    data: [],
    total_pages: 0,
    total_item: 0
  },
  search: {
    init: true,
    data: {},
    value: { plate: false, chasis: false, code_igss: false }
  },
  detail: {
    data: null,
    loading: true
  },
  view: {
    modal: false
  },
  add: {
    modal: false,
    data: { new: {} },
    loading: false
  },
  update: {
    loading: false,
    message: ''
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case AMBULANCE_LIST:
      return { ...state, loading: true };
    case AMBULANCE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: { ...state.list, ...action.payload }
      };
    case AMBULANCE_LIST_ERROR:
      return { ...state, loading: false, error: true };
    case AMBULANCE_PAGE_SET:
      return {
        ...state,
        list: { ...state.list, page: { ...state.list.page, ...action.payload } }
      };
    case AMBULANCE_SEARCH_SET:
      return {
        ...state,
        search: { ...state.search, data: action.payload }
      };
    case AMBULANCE_SEARCH_CHANGE:
      return {
        ...state,
        search: { ...state.search, value: action.payload }
      };
    case AMBULANCE_DETAIL:
      return {
        ...state,
        detail: { ...state.detail, loading: true, data: null }
      };
    case AMBULANCE_DETAIL_SUCCESS:
      return {
        ...state,
        detail: { ...state.detail, loading: false, data: action.payload }
      };
    case AMBULANCE_DETAIL_ERROR:
      return {
        ...state,
        detail: { ...state.detail, loading: false, data: null }
      };
    case AMBULANCE_VIEW_MODAL_SET:
      return {
        ...state,
        view: { ...state.view, modal: action.payload }
      };
    case AMBULANCE_MAINTENANCE_UPDATE:
      return {
        ...state,
        update: { ...state.update, loading: true }
      };
    case AMBULANCE_MAINTENANCE_UPDATE_SUCCESS:
      return {
        ...state,
        update: { ...state.update, loading: false, message: action.payload },
        add: { ...state.add, modal: false, data: { new: {} } }
      };
    case AMBULANCE_MAINTENANCE_UPDATE_ERROR:
      return {
        ...state,
        update: { ...state.update, loading: false, message: action.payload }
      };
    case AMBULANCE_ADD_MODAL_SET:
      return {
        ...state,
        add: { ...state.add, modal: action.payload }
      };
    case AMBULANCE_ADD_CHANGE:
      return {
        ...state,
        add: { ...state.add, data: { ...state.add.data, new: { ...state.add.data.new, ...action.payload } } }
      };
    default:
      return { ...state };
  }
};
